/**
 * Cache AJAX iniettata da react-snap in window.snapStore (chiavi tipo /api/v1/public/...).
 * Usata per idratare lo stato iniziale durante prerender/hydration e per replay axios.
 */

const API_PREFIX = '/api/v1';

export function isReactSnap() {
  if (typeof navigator === 'undefined') return false;
  return /ReactSnap/i.test(navigator.userAgent || '');
}

function normalizeKey(path) {
  if (!path) return '';
  const p = path.startsWith('/') ? path : `/${path}`;
  if (p.startsWith(API_PREFIX)) return p;
  return `${API_PREFIX}${p}`;
}

/** Dati cached per path API (es. `/public/medici/79` o `/api/v1/public/medici/79`). */
export function getSnapApiData(apiPath) {
  if (typeof window === 'undefined' || !window.snapStore) return undefined;
  const key = normalizeKey(apiPath);
  if (window.snapStore[key] !== undefined) return window.snapStore[key];
  const alt = key.replace(API_PREFIX, '');
  if (window.snapStore[alt] !== undefined) return window.snapStore[alt];
  return undefined;
}

/** Prima chiave snapStore che inizia con il prefisso (es. lista medici con query). */
export function getSnapApiDataByPrefix(apiPathPrefix) {
  if (typeof window === 'undefined' || !window.snapStore) return undefined;
  const prefix = normalizeKey(apiPathPrefix);
  const keys = Object.keys(window.snapStore);
  const hit = keys.find((k) => k === prefix || k.startsWith(`${prefix}?`));
  return hit ? window.snapStore[hit] : undefined;
}
